module.exports = __webpack_public_path__ + "static/img/5.1c16b37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/online/5.jpg
// module id = TlwD
// module chunks = 0